import { render, staticRenderFns } from "./admMuestra-gerente.vue?vue&type=template&id=c929f32c&"
import script from "./admMuestra-gerente.vue?vue&type=script&lang=js&"
export * from "./admMuestra-gerente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports